export default "__VITE_ASSET__BvGgaK3K__"